module.exports = __webpack_public_path__ + "img/3574b1f.png";